// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__oqBxZ","bigColWidth":"Table_bigColWidth__3LbeR","biggerColWidth":"Table_biggerColWidth__QBtwe","row":"Table_row__obg12","col":"Table_col__1u3az"};